export enum MessageChannel {
  Gmail = "gmail",
  Outlook = "outlook",
  Customemail = "customEmail",
  Redochat = "redoChat",
  Facebookdm = "facebookDm",
  Facebookcomments = "facebookComments",
  Instagramdm = "instagramDm",
  Instagramcomments = "instagramComments",
  Sms = "sms",
  Mobilemessage = "mobileMessage",
  Voice = "voice",
  Attentive = "attentive",
  Postscript = "postscript",
  Tiktok = "tiktok",
  Contactform = "contactForm",
  Internalnote = "internalNote",
}
